import { render } from "./MyEvents.vue?vue&type=template&id=2037e4fe&scoped=true"
import script from "./MyEvents.vue?vue&type=script&lang=js"
export * from "./MyEvents.vue?vue&type=script&lang=js"

import "./MyEvents.vue?vue&type=style&index=0&id=2037e4fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2037e4fe"]])

export default __exports__